module.exports = __webpack_public_path__ + "img/fuwufanchou.d00f98a6.png";